import React, { useState } from 'react'
import Logo from '../../assets/logo.png'
import Charity from '../../assets/charity-fund.png'
import Marketing from '../../assets/marketing.png'
import LottieImage from '../lottieimage/LottieImage'
import Logo01 from '../../assets/newlogo/logo01.png'
import Logo02 from '../../assets/newlogo/logo02.png'

const StarParalax = () => {

    const [alertmessage, setAlertmessage] = useState("");

    const copydata = () => {
        navigator.clipboard.writeText('0x72eb1afddb5652e0f5c7b9a6cc1c3241348b16c6')
    }

    const allertdata = () => {
        setAlertmessage("Copied")
        setTimeout(() => {
            setAlertmessage("")
        }, 700)
    }

    return (
        <div className="starparalax">
            <div id="stars"></div>
            <div id="stars2"></div>
            <div id="stars3"></div>
            <div id="title">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="main-logo-cont">
                                <div className="ring-container"
                                    data-aos="zoom-in"
                                    data-aos-delay="30"
                                    data-aos-duration="1000"
                                    data-aos-easing="ease-in-out-cubic"
                                >
                                    <div class="outer-ring center"></div>
                                    <div class="inner-ring center">
                                        {/* <img src={Logo} alt="" /> */}
                                        <LottieImage />
                                    </div>
                                </div>
                                <div className="button-container howtobuy"
                                    data-aos="fade-up"
                                    data-aos-delay="30"
                                    data-aos-duration="1000"
                                    data-aos-easing="ease-in-out-cubic"
                                >
                                    <div className="button-logo">
                                        <img src={Logo01} alt="" />
                                    </div>
                                    <div className="mission-text-container">
                                        <h1><span className="mission-text">MISSION</span>
                                            <br />
                                            <img src={Logo02} alt="" /> FOOD BANK
                                        </h1>
                                    </div>
                                    <h2>Holding $Pizza = Passive Income</h2>
                                    <a target="_blank" href="https://v1exchange.pancakeswap.finance/?outputCurrency=0x72eb1afddb5652e0f5c7b9a6cc1c3241348b16c6">Buy on PancakeSwap V1</a>
                                    <a target="_blank" href="https://tracker.safe-pizza.com/">$ Pizza Tracker</a>
                                    <h2>#FEED THE WORLD</h2>
                                </div>
                            </div>
                            <div className="token-container"
                                data-aos="fade-up"
                                data-aos-delay="30"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-out-cubic"
                            >
                                <h3>TOKEN INFO</h3>
                                <p>The Official SAFEPIZZA $PIZZA CONTRACT</p>
                                <div className="copy-buttons">
                                    <h4>0x72eb1afddb5652e0f5c7b9a6cc1c3241348b16c6</h4>
                                    <span>{alertmessage}</span> <button onClick={() => { copydata(); allertdata(); }} ><i class="far fa-copy"></i> COPY</button>
                                    <a target="_blank" href="https://bscscan.com/token/0x72eb1afddb5652e0f5c7b9a6cc1c3241348b16c6"><button>GO <i class="fas fa-chevron-right"></i></button></a>
                                </div>
                            </div>
                            <div className="qr-container"
                                data-aos="fade-up"
                                data-aos-delay="30"
                                data-aos-duration="1000"
                                data-aos-easing="ease-in-out-cubic"
                            >
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="qr-box">
                                            <img src={Charity} alt="" />
                                            <div className="qr-text">
                                                <h2>Charity Fund QR
                                                    <br />Smart Chain BNB</h2>
                                                <p>0x6eAC588745a1103395C8D6fb2F8Ada616E3be492</p>
                                                <a href="/charity">Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="qr-box">
                                            <img src={Marketing} alt="" />
                                            <div className="qr-text">
                                                <h2>Marketing RD / Exchange Donations QR
                                                    <br />Smart Chain BNB</h2>
                                                <p>0x837aea71b3A367cAFB5617E457ae3D5a46288875</p>
                                                <a href="/marketing">Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StarParalax
